import { Outlet, ScrollRestoration, useLocation } from "react-router-dom";
import Footer from "../components/Footer";
import Header from "../components/Header";
import useHeader from "~components/Header/hooks/useHeader";
import { initialPath } from "~misc/paths";
import React, { useContext, useState } from "react";
import useFooterDefaultOptions from "~components/Footer/hooks/useFooterDefaultOptions";
import ModalResponse from "~components/Modal/ModalResponse";
import GlobalContextProvider from "~/GlobalContextProvider";
import useNavigationUrl from "~services/utils/useNavigationUrl";
import SyncLoadingFullScreen from "~/components/Geral/SyncLoadingFullScreen";
import ModalSync from "~components/Modal/ModalSync";
import { useModalSyncContext } from "~/context/ModalSyncContext";
import useUsuario from "~fetchs/useUsuario";
import DeviceBlocked from "~components/DeviceBlocked";
import SMDataSourceButton from "~pages/SalesManagement/components/SMDataSourceButton";

import {
  isTablet,
  isDesktop,
  isMobile
} from "react-device-detect";

const MainLayout = ({ children }) => {
  const { path } = useHeader();
  const { pathname } = useLocation();
  const [footerSpace, setFooterSpace] = useState(null);

  const { defaultOptions } = useFooterDefaultOptions();

  const [footerOptions, setFooterOptions] = useState(defaultOptions);

  const { contextData, setContextData } = useContext(GlobalContextProvider);

  const {handleSync, handleClose, showModalSync} = useModalSyncContext();
  const { usuario, usuarioDivergente, recarregarUsuario, recarregandoUsuario } = useUsuario();

  useNavigationUrl();

  const deviceAcess = (usuario) => {
    const allowed = usuario?.dispositivoAcesso;

    if (!allowed || allowed.length === 0) {
      return true;
    }
    const device =
      (isMobile && "mobile") ||
      (isTablet && "tablet") ||
      (isDesktop && "desktop");

    return allowed.includes(device);
  };

  if (!deviceAcess(usuario)) {
    return <DeviceBlocked device={usuario?.dispositivoAcesso} />;
  }

  return (
    <>
      <ScrollRestoration />
      <Header.Root>
        <Header.Infos />
        <Header.Menu />
        <Header.Buttons />
      </Header.Root>

      <ModalResponse
        {...contextData}
        status={
          contextData.message === "O sistema passa por instabilidade. Tente novamente em alguns instantes."
            ? "warning"
            : contextData.status
        }
        closeModal={() => {
          if (contextData.onCloseModal && typeof contextData.onCloseModal == "function") {
            contextData.onCloseModal();
          }

          setContextData({
            isOpen: false,
          });
        }}
      />

      {
        showModalSync && (
          <ModalSync
            title="Seu sistema está sem sincronização de dados!"
            sub="Sincronize novamente para garantir o bom funcionamento e atualização das informações"
            isOpen={showModalSync}
            onClose={handleClose}
            onClick={handleSync}
          />
        )
      }

      {
        usuarioDivergente && (
          <ModalSync
            title="Não foi possível confirmar seu usuário!"
            sub="Os dados recebidos não correspondem à conta conectada. Tente novamente."
            isOpen={usuarioDivergente}
            onClick={() => recarregarUsuario()}
            buttonLabel={recarregandoUsuario ? "Verificando..." : "Tentar novamente"}
          />
        )
      }

      <main className={`${path === initialPath && "pt-4"}`} style={{ paddingBottom: `${footerSpace * 1.2}px` }}>
        <Outlet context={{ footerOptions, setFooterOptions }} />
      </main>

      <Footer options={footerOptions} setOptions={setFooterOptions} setFooterSpace={setFooterSpace} />

      {pathname.startsWith("/gestao-de-vendas/") && <SMDataSourceButton />}

      <SyncLoadingFullScreen />
    </>
  );
};

export default MainLayout;
